'use memo';

import type { i18n } from 'i18next';
import type { ReactNode } from 'react';
import {
  Translation as TranslationBase,
  type TranslationProps,
} from 'react-i18next';

import type { LegacyStringTFunction } from './i18next-types';

/**
 * enableSelector 移行中は string key の t を渡すため、
 * react-i18next の TranslationProps デフォルト（Ns/KPrefix = undefined）とは別に props を定義する。
 */
type TranslationRenderProps = {
  children: (t: LegacyStringTFunction) => ReactNode;
  ns?: string | readonly string[];
  keyPrefix?: string;
  i18n?: i18n;
  useSuspense?: boolean;
  nsMode?: 'fallback' | 'default';
};

export function Translation({ children, ...props }: TranslationRenderProps) {
  return (
    <TranslationBase {...(props as TranslationProps)}>
      {(t) => children(t as unknown as LegacyStringTFunction)}
    </TranslationBase>
  );
}
